var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img_src)?_c('img',{ref:"imgRef",class:_vm.imgClass,style:(_vm.imgStyle),attrs:{"id":"cjimg-snipaste","src":_vm.img_src},on:{"load":_vm.imgLoad,"error":_vm.loadDefaultImg,"click":_vm.click}}):_c('img',{ref:"imgRef",class:_vm.imgClass,style:(_vm.imgStyle),attrs:{"id":"cjimg-snipaste","src":_vm.defaultUrl},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }